// extracted by mini-css-extract-plugin
module.exports = {"separator":"styles_separator__w76Kn","top":"styles_top__vTMwf","background":"styles_background__gBwTk","angle":"styles_angle__pYvzH","bottom":"styles_bottom__Ax6kj"};